import api from "./api";
import StorageService from "./StorageService";

const ProjectEstimatesService = {
    getAll: async (page = 1, limit = 10, filters = {}) => {
        try {
            let url = `/project-estimates?page=${page}&limit=${limit}`;
            if (filters.projectId) url += `&projectId=${filters.projectId}`;
            if (filters.expenditureTypeId) url += `&expenditureTypeId=${filters.expenditureTypeId}`;
            if (filters.status) url += `&status=${filters.status}`;
            const res = await api.get(url);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || "Failed to fetch project estimates");
            } else {
                throw new Error("Unable to connect to server");
            }
        }
    },

    getById: async (id) => {
        try {
            const res = await api.get(`/project-estimates/${id}`);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || "Failed to fetch project estimate");
            } else {
                throw new Error("Unable to connect to server");
            }
        }
    },

    create: async (data) => {
        try {
            const payload = { ...data, createdBy: StorageService.loginData().employeeId };
            const res = await api.post("/project-estimates", payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || "Failed to create project estimate");
            } else {
                throw new Error("Unable to connect to server");
            }
        }
    },

    update: async (id, data) => {
        try {
            const payload = { ...data, updatedBy: StorageService.loginData().employeeId };
            const res = await api.put(`/project-estimates/${id}`, payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || "Failed to update project estimate");
            } else {
                throw new Error("Unable to connect to server");
            }
        }
    },

    updateStatus: async (id, status) => {
        try {
            const res = await api.patch(`/project-estimates/${id}/status`, { status, updatedBy: StorageService.loginData().employeeId });
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || "Failed to update project estimate status");
            } else {
                throw new Error("Unable to connect to server");
            }
        }
    }
};

export default ProjectEstimatesService;